<template>
 <div class="search_container">
     <div class="top_box">
            <!-- 头部搜索框 -->
        <div class="search">
                <input type="text" class="search_key" placeholder="退货单号/退货商家/退货人姓名" v-model="searchkey"/>
                <span class="search_btn" @click="startSeach">搜索</span>
                <img src="../../../../assets/image/search.png" class="search_img"/>
        </div>
      </div>
      <div class="wrapper">
           <div class="reject" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.flowId)">
                <div class="reject_item">
                    <div class="item_box">
                        <p class="title_text">{{item.product}}</p>
                        <div class="info">
                            <span>所属区域:</span>
                            <span>{{item.geography}}</span>
                        </div>
                        <div class="info">
                            <span>商家名称:</span>
                            <span>{{item.shoppingStore}}</span>
                        </div>
                        <div class="info">
                            <span>退货人:</span>
                            <span>{{item.purchaser}}</span>
                        </div>
                        <div class="info">
                            <span>商品金额:</span>
                            <span>{{item.shoppingAmount}}</span>
                        </div>
                        <div class="info">
                            <span>商品类型:</span>
                            <span>{{item.productType | filt1}}</span>
                        </div>
                        <div class="info">
                            <span>退货时间:</span>
                            <span>{{item.refundTime|filt()}}</span>
                        </div>
                        <div class="info">
                            <span>退货单号:</span>
                            <span>{{item.orderNumber}}</span>
                        </div>
                    </div>
                    <div class="line line_bottom"></div>
                    <div class="status">
                        <span class="left">{{item.statusText}}</span>
                        <div class="right">
                                <span>查看更多</span>
                                <img src="../../../../assets/image/icon_right.png"/>
                        </div>
                    </div>
                </div>
           </div>
            <div class="box" v-if="isNolist">
                    <img src='../../../../assets/empty/ic_wusousuo.png'/>
                    <p class="tip1">暂无数据</p>
            </div>
      </div>
 </div>
</template>
<script>
    import util from '../../../../utils/common'
    import moment from 'moment'
    import api from '../../../../service/modules/refund'
    export default {
        components: {
        },
        data () {
            return {
                isNolist: false,
                searchkey: '',
                pageIndex: '1',
                pageSize: '10',
                areaId: this.$router.currentRoute.query.citycode,
                dataList: []
            }
        },
        created () {

        },
        methods: {
            goDetail (value) {
                this.$store.state.refund.flowId = value;
                this.$router.push('/refund/refundDetail?flowId=' + value);
            },
            startSeach () {
                if (this.searchkey.trim().length === 0) {
                    this.$Toast({
                        message: '请输入查询条件~'
                    })
                } else {
                    this.getReturnList();
                }
            },
            getReturnList () {
                api.returnList({ 'startDate': '',
                                 'endDate': '',
                                 'refundChannel': '',
                                 'areaId': this.areaId,
                                 'pageIndex': this.pageIndex,
                                 'pageSize': this.pageSize,
                                 'searchStr': this.searchkey,
                                 'status': '',
                                 'refundType': '',
                                 'isCenterReceipt': '' }).then((res) => {
                                     console.log(res);
                                     if (res.ret === 0) {
                                         this.dataList = res.data.list;
                                         if (this.dataList.length === 0) {
                                             this.isNolist = true;
                                         } else {
                                             this.isNolist = false;
                                         }
                                     }
                                 })
            }
        },
        filters: {
            filt (value) {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
            },
            filt1 (value) {
                var config = util.getJsonLocal('configList').PRODUCT_TYPE || [];
                let name = '';
                config.forEach((item, index) => {
                    if (item.code === value) {
                        name = item.name
                    }
                })
                return name;
            },
            filt2 (value) {
                var config = util.getJsonLocal('configList').WORK_ORDER_FLOW;
                let name = '';
                config.map((item, index) => {
                    if (item.code === value) {
                        name = item.name
                    }
                })
                return name;
            }
        }
    }
</script>
<style scoped lang="scss">
.search_container{
     width:100%;
     height:100%;
     background-color:#fbfbfb;
    .top_box{
        width:100%;
        position: fixed;
        left:0;
        top:0;
        z-index: 2;
        background-color:#fff;
        .search{
            width:100%;
            padding:12px 0;
            position: relative;
            // margin-top:10px;
            .search_key{
                width:297px;
                height:36px;
                // background: #F8F8F8;
                // border-radius: 18px;
                margin-left:15px;
                font-size:13px!important;
                padding-left:39px;
                box-sizing: border-box;
                border:0;
                outline: none;
                line-height: 36px;
                border-radius: 3px;
                border:1px solid #eeeeee;
            }
            .search_btn{
                font-size:14px;
                margin-left:16px;
            }
            .search_img{
                width:15px;
                height:14px;
                position: absolute;
                left:25px;
                top:23px;
            }
        }
    }
    .wrapper{
      width:100%;
      padding-top:70px;
     .reject{
        width:100%;
        background-color: #fff;
        padding-bottom:16px;
        .reject_item {
            margin-left: 12px;
            margin-right: 12px;
            box-sizing: border-box;
            background-color: #ffffff;
            box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
            border-radius: 3px;
           .item_box {
             padding: 16px;
            .title_text {
                font-size: 16px;
                font-weight: 700;
                color: #2a2a2a;
                // margin-bottom: 16px;
                line-height: 24px;
            }
            .info {
                margin-top: 12px;
                span:nth-child(1) {
                display: inline-block;
                width: 65px;
                font-size: 14px;
                color: #777;
                }
                span:nth-child(2) {
                display: inline-block;
                font-size: 14px;
                color: #777;
                margin-left: 12px;
                }
            }
        }
        .line {
          width: 100%;
          height: 1px;
        }
        .status {
          width: 100%;
          padding: 15px 16px;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          justify-content: space-between;
          align-items: center;
          .left{
            font-size:14px;
            color:#333;
          }
          .right{
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            align-items: center;
            img{
              width:4px;
              height:7px;
              margin-left:4px;
              margin-top:-3px;
            }
            span{
               font-size:12px;
               color:#999;

            }
          }

        }

      }
     }
     .box{
        text-align: center;
        margin-top:216px;
        img{
            display: inline-block;
            width:74px;
            height:62px;
        }
        .tip1{
            font-size:14px;
            color:#9B9B9B;
            margin-top:24px;

        }
    }
    }
}
</style>
